// extracted by mini-css-extract-plugin
module.exports = {"chevron":"Chevron_chevron__1DSK-","chevronRight":"Chevron_chevronRight__25Sr2","chevronLeft":"Chevron_chevronLeft__1_YPh","open":"Chevron_open__JDgZq"};